<button mat-icon-button (click)="toggleFullscreen()">
  <mat-icon *ngIf="!screen.isFullscreen">fullscreen</mat-icon>
  <mat-icon *ngIf="screen.isFullscreen">fullscreen_exit</mat-icon>
</button>
